<template>
  <!-- 通过命名路由的方式跳过母版页直接显示某个组件 -->
  <div>
    <router-view name="login"></router-view>
  </div>
  <div v-if="!isLoginRoute">
    <mainSite />
  </div>
</template>

<script setup>
import mainSite from '@/components/main.vue'
import { ref, watchEffect } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const isLoginRoute = ref(route.path === '/login');

watchEffect(() => {
  isLoginRoute.value = route.path === '/login';
});
</script>